// src/context/NovuUIContext.tsx
import React from "react";
import { assertContextExists, createContextAndHook } from "../utils/createContextAndHook.js";
import { jsx } from "react/jsx-runtime";
var [NovuUIContext, useNovuUIContext, useUnsafeNovuUIContext] = createContextAndHook("NovuUIContext");
var NovuUIProvider = (props) => {
  return /* @__PURE__ */ jsx(NovuUIContext.Provider, { value: { value: props.value }, children: props.children });
};
var OutletScopeContext = React.createContext(void 0);
OutletScopeContext.displayName = "OutletScopeContext";
var OutletScopeProvider = OutletScopeContext.Provider;
var useOutletScope = () => React.useContext(OutletScopeContext);
var useOutlets = () => {
  const outlets = React.useContext(OutletScopeContext);
  assertContextExists(
    outlets,
    "Render props must be adapted inside an OutletScope, so the component that owns them hosts their portals"
  );
  return outlets;
};
export {
  NovuUIProvider,
  OutletScopeProvider,
  useNovuUIContext as useNovuUI,
  useOutletScope,
  useOutlets,
  useUnsafeNovuUIContext as useUnsafeNovuUI
};
//# sourceMappingURL=NovuUIContext.js.map